import script from "./BudgetDashboardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BudgetDashboardPage.vue?vue&type=script&setup=true&lang=js"

import "./BudgetDashboardPage.vue?vue&type=style&index=0&id=9e5a6afc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e5a6afc"]])

export default __exports__